import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Aside = _resolveComponent("Aside");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "min-width": "auto"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      class: "aside",
      style: _normalizeStyle({
        '--background-color': _ctx.$store.state.BackgroundStatus.BackgroundColor
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_Aside)]),
      _: 1
    }, 8, ["style"])]),
    _: 1
  });
}